import {Scrollbox} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameAnimation} from '../UIGameEventController'
import {PlayerColor} from '@colonist/game-states'

export class UIGameOpponentsViewScrollAnimationController implements UIGameAnimation {
    private readonly uiGameManager: UIGameManager
    private readonly opponentsScrollbox: Scrollbox
    private maxScrollAmount: number
    private scrollDestination: number
    private previousTurnPlayerColor: PlayerColor

    constructor(uiGameManager: UIGameManager, opponentsScrollBox: Scrollbox) {
        this.uiGameManager = uiGameManager
        this.opponentsScrollbox = opponentsScrollBox
        this.previousTurnPlayerColor = PlayerColor.None
    }

    onGameTick() {
        this.scroll()
    }

    animate(desiredScrollbarPosition: number) {
        const currentTurnPlayerColor = this.uiGameManager.gameController.currentState.currentTurnPlayerColor
        if(this.previousTurnPlayerColor == currentTurnPlayerColor) return
        this.setMaxScrollAmount()

        this.previousTurnPlayerColor = currentTurnPlayerColor
        this.scrollDestination = desiredScrollbarPosition > this.maxScrollAmount ? this.maxScrollAmount : desiredScrollbarPosition
        this.startAnimation()
    }

    private setMaxScrollAmount() {
        this.maxScrollAmount = this.opponentsScrollbox.content.height - this.opponentsScrollbox.boxHeight
    }

    private startAnimation() {
        this.uiGameManager.eventController.registerUIGameAnimation(this)
    }

    private stopAnimation() {
        this.uiGameManager.eventController.unregisterUIGameAnimation(this)
    }

    private scroll() {
        if(this.opponentsScrollbox.destroyed) {
            this.stopAnimation()
            return
        }

        const scrollAmountPerTick = this.uiGameManager.canvasController.itemSize / 20
        const scrollPosition = 'scrollTop'
        const scrollDirection = this.opponentsScrollbox[scrollPosition] < this.scrollDestination ? 1 : -1
        this.opponentsScrollbox[scrollPosition] += scrollAmountPerTick * scrollDirection

        const isScrollComplete = Math.abs(this.opponentsScrollbox[scrollPosition] - this.scrollDestination) < scrollAmountPerTick
        if(!isScrollComplete) return

        this.opponentsScrollbox[scrollPosition] = this.scrollDestination
        this.stopAnimation()
    }
}
